// import React, { useState, useEffect } from "react";
// import { useInView } from "react-intersection-observer";
// import "../../assets/css/hero.css";
// import CountUp from "react-countup";
// import globe from "../../assets/img/globe.png";
// import bannerVideo from "../../assets/videos/home-banner.mp4";
// import "animate.css";
// import { useNav } from "../../context/nav-context";

// const Hero = () => {
//   const [ref, inView] = useInView({
//     triggerOnce: false, // Trigger animations each time the element comes into view
//     threshold: 0.2, // Trigger when 20% of the component is visible
//   });
//   const { setActiveLink } = useNav();
//   // Update activeLink to "journey" when this section is in view
//   useEffect(() => {
//     if (inView) {
//       setActiveLink("home");
//     }
//   }, [inView, setActiveLink]);
//   return (
//     <div ref={ref} className="p-2" id="home">
//       <div className={`hero`}>
//         <div className="hero-videos">
//           <video src={bannerVideo} loop autoPlay muted></video>
//         </div>
//         <div className="container hero-content">
//           <div className="d-flex align-items-center">
//             <div className="w-50">
//               <h2
//                 className={`fs-80 fw-400 text-theme text-yellow ${
//                   inView
//                     ? "animate__animated animate__slideInLeft"
//                     : "animate__animated animate__slideInRight"
//                 }`}
//               >
//                 <span className="text-brown">Where Smiles</span>{" "}
//                 <span className="text-dark">Blossom into</span> Stories
//               </h2>

//               <a
//                 href="#contact"
//                 className={`text-decoration-none rounded-5 py-2 px-4 d-none d-lg-block mt-5 btn-theme w-50 text-center fs-14 text-white ${
//                   inView
//                     ? "animate__animated animate__slideInUp"
//                     : "animate__animated animate__slideInDown"
//                 }`}
//                 style={{
//                   whiteSpace: "nowrap",
//                 }}
//               >
//                 Book Appointment
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Hero;
import React, { useState, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import "../../assets/css/hero.css";
import "animate.css";
import { useNav } from "../../context/nav-context";

const Hero = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Load video only once when in view
    threshold: 0.2,
  });

  const { setActiveLink } = useNav();
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  useEffect(() => {
    if (inView) {
      setActiveLink("home");
      setIsVideoLoaded(true); // Load video only when in view
    }
  }, [inView, setActiveLink]);

  return (
    <div ref={ref} className="p-2" id="home">
      <div className={`hero`}>
        <div className="hero-videos">
          {isVideoLoaded && (
            <video
              src={require("../../assets/videos/aligar.mp4")}
              loop
              autoPlay
              muted
              playsInline
              preload="metadata"
            ></video>
          )}
        </div>
        <div className="container hero-content">
          <div className="d-flex align-items-center">
            <div className="w-md-50 w-100">
              <h2
                className={`fs-80 fw-400 text-theme text-yellow ${
                  inView
                    ? "animate__animated animate__slideInLeft"
                    : "animate__animated animate__slideInRight"
                }`}
              >
                <span className="text-brown">Where Smiles</span>{" "}
                <span className="text-dark">Blossom into</span> Stories
              </h2>

              <a
                href="#contact"
                className={`text-decoration-none rounded-5 py-2 px-4 d-none d-lg-block mt-5 btn-theme w-50 text-center fs-14 text-white ${
                  inView
                    ? "animate__animated animate__slideInUp"
                    : "animate__animated animate__slideInDown"
                }`}
                style={{ whiteSpace: "nowrap" }}
              >
                Book Appointment
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
